(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-description-disclosure]').forEach(disclosure => {
      if (disclosure.dataset.disclosureReady) return;
      disclosure.dataset.disclosureReady = 'true';
      const content = disclosure.querySelector('[data-description-content]');
      const button = disclosure.querySelector('[data-description-toggle]');
      if (!content || !button) return;
      const sync = () => {
        if (button.getAttribute('aria-expanded') === 'true') return;
        content.classList.add('description-collapsed');
        button.hidden = content.scrollHeight <= content.clientHeight + 1;
      };
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
        content.classList.toggle('description-collapsed', !expanded);
        if (!expanded) sync();
      });
      sync();
      if (window.ResizeObserver) new ResizeObserver(sync).observe(content);
    });
    document.querySelectorAll('[data-footer-disclosure]').forEach(details => {
      if (details.dataset.disclosureReady) return;
      details.dataset.disclosureReady = 'true';
      const summary = details.querySelector('summary');
      const mobile = matchMedia('(max-width:760px)');
      function sync() {
        details.open = !mobile.matches;
        if (mobile.matches) summary.removeAttribute('tabindex');
        else summary.tabIndex = -1;
      }
      summary.addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      });
      mobile.addEventListener('change', sync);
      sync();
    });
    const menu = document.getElementById('menu-dialog');
    if (!menu || menu.dataset.navigationReady) return;
    menu.dataset.navigationReady = 'true';
    const resets = [];
    menu.querySelectorAll('[role="tabpanel"] .mega-columns').forEach(columns => {
      const groups = Array.from(columns.children).filter(node => node.tagName === 'DIV' && node.querySelector('h3'));
      if (!groups.length) return;
      const root = document.createElement('div');
      root.className = 'menu-level-root';
      const back = document.createElement('button');
      back.type = 'button'; back.className = 'menu-level-back'; back.hidden = true;
      let previous;
      const buttons = groups.map((group, index) => {
        group.id = columns.closest('[role="tabpanel"]').id + '-level-' + index;
        const title = group.querySelector('h3').textContent.trim();
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'menu-level-trigger'; button.textContent = title;
        button.setAttribute('aria-controls', group.id); button.setAttribute('aria-expanded', 'false');
        const arrow = document.createElement('span'); arrow.textContent = '›'; arrow.setAttribute('aria-hidden', 'true'); button.append(arrow);
        button.addEventListener('click', () => {
          previous = button;
          groups.forEach(other => { other.hidden = other !== group; });
          buttons.forEach(other => other.setAttribute('aria-expanded', String(other === button)));
          root.hidden = true; back.hidden = false;
          back.textContent = '‹ ' + title;
          back.setAttribute('aria-label', (menu.dataset.backLabel || 'Back') + ': ' + title);
          back.focus();
        });
        root.append(button); return button;
      });
      const reset = restoreFocus => {
        groups.forEach(group => { group.hidden = true; });
        buttons.forEach(button => button.setAttribute('aria-expanded', 'false'));
        root.hidden = false; back.hidden = true;
        if (restoreFocus && previous) previous.focus();
      };
      back.addEventListener('click', () => reset(true));
      columns.prepend(back, root); reset(false); resets.push(reset);
    });
    menu.addEventListener('close', () => resets.forEach(reset => reset(false)));
    menu.querySelectorAll('[role="tab"]').forEach(tab => tab.addEventListener('click', () => resets.forEach(reset => reset(false))));
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
